import { Type } from "class-transformer";
import { User } from "../user/user.model";

export class BidpoolFeedback {
  id: number;
  createdAt: string;
  feedback: string;
  @Type(() => User)
  user: User;
}
